package com.wintermar.inspection.core.ui.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

@Composable
fun LoadingDialog(
    isLoading: Boolean,
    message: String = "",
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color
) {
    if (!isLoading) {
        return
    }

    Dialog(
        properties = DialogProperties(
            dismissOnBackPress = false,
            dismissOnClickOutside = false
        ),
        onDismissRequest = {
            // no-op
        }
    ) {
        Column(
            modifier = Modifier.background(
                color = color.surface.normal,
                shape = RoundedCornerShape(dimension.radius.md)
            ).padding(vertical = dimension.spacing.space4, horizontal = dimension.spacing.space5),
            verticalArrangement = Arrangement.spacedBy(
                space = dimension.spacing.space4,
                alignment = Alignment.CenterVertically
            ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            CircularProgressIndicator(
                color = color.icon.brand,
                modifier = Modifier.size(LocalAppTheme.current.dimension.size.icon.s),
            )

            if (message.isNotEmpty()) {
                TextBodySmall(text = message, color = { it.subtle })
            }
        }
    }
}
